/* ---------------------------------------

    -- マウス動作に合わせていい感じに値を返すやつ

--------------------------------------- */

export default class MouseManager{
    constructor(isTablet) {

        /* ポインターの位置情報 */
        this.pointer = {
            x : 0,
            y : 0,
            ox: 0,
            oy: 0
        }
        /* 慣性動作後の値 */
        this.obj = {
            x : 0,
            y : 0
        }

        /* 設定はここ */
        this.conf = {
            ease : 0.05,
        }

        this.status={
            off : false,
            deviceSize : "pc",
            comp : false,
            fit :{
                out : false
            },
            mode:"full",
            prevMode:"full",
            size:{
                full:{
                    w:740,
                    h:740,
                },
                half:{
                    w:370,
                    h:370,
                },
            }
        }


        this.$container;
        this.$circle;
        this.$hover;

        this.isTablet = isTablet

    }
    init(pageID){
        this.status.off = pageID == "top" ? true : false;

        this.$container = document.getElementById("l-mousepointer");
        this.$circle = this.$container.querySelectorAll(".circle");
        this.$hover = document.querySelectorAll(".js__mp-hover");

        // for(let i in this.$circle){
        //     if(this.$circle[i].nodeType!=1) continue; // dom要素以外は処理止める
        //
        //     TweenMax.to(this.$circle[i],3,{
        //         rotation:360,
        //         transformOrigin:"50% 50%",
        //         repeat:-1,
        //         ease: Power0.easeNone
        //     })
        //
        // }
        TweenMax.staggerTo(this.$container.querySelectorAll(".circle__inner"),3,{
            width:100+"%",
            height:100+"%",
            opacity:1,
            delay:2,
            ease: Expo.easeOut
        },0.1,()=>{
            TweenLite.set(this.$container.querySelectorAll(".circle__inner"),{overflow:"inherit"});
        });

        TweenMax.to(this.$circle,3,{
            rotation:360,
            transformOrigin:"50% 50%",
            repeat:-1,
            ease: Power0.easeNone
        })

        for(let i in this.$hover){
            if(this.$hover[i].nodeType!=1) continue; // dom要素以外は処理止める
            this.$hover[i].addEventListener("mouseenter", (e) => {

                this.modeChange("enter","enter");

            });

            this.$hover[i].addEventListener("mouseleave", (e) => {
                this.modeChange(this.status.prevMode,"leave");

            });

        }


    }
    pointerColor(){
        // TweenMax.to(this.$circle,0.6,{
        //    borderColor
        // });
    }
    modeChange(mode,event){


        if(this.status.mode==mode||this.status.mode=="enter"&&event=="scroll") return;
        this.status.mode = mode;
        this.status.prevMode = event=="scroll"?mode:this.status.prevMode;

        if(mode=="full") {

            this.status.size.full.w = 740;
            this.status.size.full.h = 740;
        }else if(mode=="enter"){
            this.status.size.full.w = 148;
            this.status.size.full.h = 148;
        }else{
            this.status.size.full.w = 70;
            this.status.size.full.h = 70;
        }

        this.status.size.half.w = this.status.size.full.w/2;
        this.status.size.half.h = this.status.size.full.h/2;


        // TweenMax.killChildTweensOf(this.$container,{width:true,height:true});
        TweenMax.to(this.$container.children,1,{
            width:this.status.size.full.w,
            height:this.status.size.full.w,
        });

        this.pointer.ox = this.pointer.x - this.status.size.half.w;
        this.pointer.oy = this.pointer.y - this.status.size.half.h;

    }
    on(mode){



    }
    move(type){ /* domにスタイル付けるなら("set",$target) | 値が欲しいだけなら()なし */

        if(this.status.off||this.status.comp) return;

        this.obj.x += (this.pointer.ox-this.obj.x)*this.conf.ease;
        this.obj.y += (this.pointer.oy-this.obj.y)*this.conf.ease;

        TweenLite.set(this.$container,{ x:this.obj.x,y:this.obj.y });

        if(this.pointer.ox<this.obj.x+0.01&&this.pointer.oy<this.obj.y+0.01){
            // this.status.comp = true;
        }

    }
    fit($target){

        if(this.status.off||this.status.deviceSize=="sp"||Useragnt.mobile||this.isTablet) return;

        let _w = $target.clientWidth,
            _h = $target.clientHeight,
            _rect = $target.getBoundingClientRect(),
            _x = _rect.left,
            _y = _rect.top,
            _fx = (this.pointer.x - _x) / _w - 0.5,
            _fy = (this.pointer.y - _y) / _h - 0.5;

        // console.log("fitHoverMove",_x,_y,_fx,_fy,_rect,this.state.mouse.x)
        TweenLite.to($target.getElementsByClassName("js__m-fit"),0.2,{
            x:_fx * _w * 0.5,
            y:_fy * _h * 0.5
        });



    }
    update(x,y){
        if(this.status.off) return;
        // this.makeTex.uniforms.mouse.value.x = mouse.obj.x + window.innerWidth/2;
        // this.makeTex.uniforms.mouse.value.y = window.innerHeight - mouse.obj.y;

        this.status.comp = false;
        if(Useragnt.pc){
            this.pointer.x = x;
            this.pointer.y = y;
            this.pointer.ox = x - this.status.size.half.w;
            this.pointer.oy = y - this.status.size.half.h;
        }else{
            this.pointer.x = x;
            this.pointer.y = -y;
        }
    }
}